<script>
export default {
  name: 'CheckoutPayPal',
  props: {
    orderId: { type: Number }
  },
  data: () => ({
    paypalLoaded: false,
    inProgress: false
  }),
  mounted: function() {
    //open paypal client
    const script = document.createElement('script')
    script.src =
      'https://www.paypal.com/sdk/js?client-id=' +
      window.config.VUE_APP_CHECKOUT_PAYPAL_ID +
      '&currency=EUR' +
      '&disable-funding=sepa,giropay,sofort'
    script.setAttribute('data-namespace', 'checkoutPayPal')
    script.addEventListener('load', this.loaded)
    this.$refs.checkoutPayPal.appendChild(script)
  },
  methods: {
    loaded: function() {
      this.paypalLoaded = true
      const that = this
      // Render the PayPal button into #paypal-button-container
      window.checkoutPayPal
        .Buttons({
          locale: 'de_DE',
          style: {
            color: 'blue',
            shape: 'pill',
            label: 'pay',
            height: 40
          },
          // Set up the transaction
          createOrder: function() {
            return that.$ordersService
              .checkout(that.orderId)
              .then(checkoutResponse => {
                return checkoutResponse.orderID
              })
              .catch(() => {
                // nothing
              })
          },
          // Finalize the transaction
          onApprove: function(data) {
            that.inProgress = true
            return that.$ordersService
              .payment(that.orderId, {
                orderID: data.orderID,
                payerID: data.payerID,
                facilitatorAccessToken: data.facilitatorAccessToken
              })
              .then(() => {
                that.$emit('onApproved', true)
                that.inProgress = false
              })
              .catch(() => {
                that.inProgress = false
              })
          },
          onCancel: function(data) {
            that.$emit('onCancel', data.orderID)
          }
        })
        .render(this.$refs.checkoutPayPal)
    }
  }
}
</script>
<template>
  <div>
    <v-overlay :value="inProgress" z-index="9999"
    ><v-card loading>
      <v-card-title>
        <span>{{ $t('component.checkout.checkoutPayPal.please.wait.header') }}</span>
      </v-card-title>
      <v-card-text>{{ $t('component.checkout.checkoutPayPal.please.wait.content') }}</v-card-text>
    </v-card>
    </v-overlay>
    <div ref="checkoutPayPal" />
  </div>
</template>
